<template>
  <v-container fluid> 
    <h1>{{document.title}}</h1>
    <div class="text">
        {{document.description}}
    </div>
  </v-container>
</template>

<script>
import data from '@/assets/content.json'
export default {
  metaInfo: {
    title: 'Punt'
  },
 data() {
   return {
     documents: data.pois,
     document: {}
   }
 },
 computed: {
   data() {
     return this.documents
   }
 },
 mounted() {
   this.getDoc()
 },
 watch: {
   $route() {
     this.getDoc()
   }
 },
 methods: {
   getDoc() {
       const docs = this.documents.filter(doc => doc.id === this.$route.params.id);
      if (docs.length > 0) 
        this.document =  docs[0];
   }
 }
}
</script>

<style>

</style>
